import React from 'react'
import _ from 'lodash'

import { booleanToText, formatToCurrency } from 'utils/functions'

import Container from './styles'
import NoDataFoundMessage from '../NoDataFoundMessage'

const IrReceiptValues = ({ receiptData }) => {

  const receiptValues = {
    taxable_income: { value: receiptData?.taxable_income, label: 'Total de Rendimentos Tributáveis', currency: 'BRL' },
  }

  const hasReceiptValues = _.some(receiptValues, (value) => !_.isNil(value))

  return (
    <React.Fragment>
      <Container>
        <h2>
          <ul>
            <li>Arquivo de Recibo</li>
          </ul>
        </h2>
      </Container>

      {_.isEmpty(receiptData) ? (
        <NoDataFoundMessage message="Arquivo de recibo não enviado" />
          ) : (
            <Container>

              <div className="values-file-container">
                <React.Fragment>
                  <div className="text-container">
                    <p>
                      <strong>{`Recibo válido: ${booleanToText(receiptData.valid)}`}</strong>
                    </p>
                  </div>

                  <br />

                  <h2>Identificação e comparações</h2>

                  <div className="table-container" style={{ fontSize: '1.5rem' }}>
                    <table>
                      <thead>
                        <tr>
                          <th>Dados do recibo</th>
                          <th>Dados iguais aos da declaração?</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <strong>Tipo da declaração:</strong>
                            {' '}
                            <span>{receiptData.type_receipt}</span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span>{booleanToText(receiptData.type_receipt_valid)}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>CPF:</strong>
                            {' '}
                            <span>{receiptData.cpf}</span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span>{booleanToText(receiptData.cpf_valid)}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Nome:</strong>
                            {' '}
                            <span>{receiptData.name}</span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span>{booleanToText(receiptData.name_valid)}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Ano do calendário:</strong>
                            {' '}
                            <span>{receiptData.calendar_year}</span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span>{booleanToText(receiptData.calendar_year_valid)}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            <strong>Ano do exercício:</strong>
                            {' '}
                            <span>{receiptData.exercise_year}</span>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <span>{booleanToText(receiptData.exercise_year_valid)}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  { hasReceiptValues && (
                    <React.Fragment>
                      <br />

                      <h2>Valores extraídos do recibo</h2>

                      <div className="table-container" style={{ fontSize: '1.5rem' }}>
                        <table>
                          <thead>
                            <tr>
                              <th>Item</th>
                              <th>Valor</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(receiptValues).filter(([_k, { enabled }]) => enabled !== false).map(([key, { value, label, currency }]) => (
                              <tr key={key}>
                                <td>
                                  <strong>
                                    {label}
                                    :
                                  </strong>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                  <span>
                                    {' '}
                                    {currency ? formatToCurrency(value, { withSymbol: true, currency }) : value}
                                  </span>
                                </td>
                              </tr>

                            ))}
                          </tbody>
                        </table>

                      </div>
                    </React.Fragment>
)}
                </React.Fragment>
              </div>
            </Container>
          )}
    </React.Fragment>
  )
}

export default IrReceiptValues
